import idb from '@/db/idb'
import store from '@/store/store'

export default {
  async init(p) {
    var db = await idb.getRecord('database');
    if (db && db.db && db.allow_backups) {
      console.log("Starting Sync");
      let d = db.db;
      console.log("Starting Sync");
    var sync = p
      .sync(process.env.VUE_APP_DB, `${d}`, {
        live: true,
        retry: true,
      })

    sync.on("connected", (d) => {
      console.log("Succesfully connected to remote")
      store.dispatch('changeDBState', {
        a: false,
        m: 'success',
        s: 'Database Connected Successfully'
      })
    })

    sync.on("change", (info) => {
      console.log("Changes detected ", info);
      store.dispatch('changeDBState', {
        a: false,
        m: 'success',
        s: `Database ${info.direction === 'pull' ? 'download' : 'upload'} in progress  ${info.direction === 'pull' ? '(Remaining Records '+ info.change.pending + ')' : ''}`
      })
    })
    sync.on("paused", (err) => {
      console.log("Sync paused ", err);
      if (err) {
        sync.cancel();
      }
      store.dispatch('changeDBState', {
        a: false,
        m: 'primary',
        s: 'Database Idle'
      })
    })
    sync.on("active", () => {
      console.log("Replication resumed");
      store.dispatch('changeDBState', {
        a: false,
        m: 'success',
        s: `Database sync started`
      })
    })
    sync.on("denied", (err) => {
      console.log("A document failed to replicate", err);
      store.dispatch('changeDBState', {
        a: true,
        m: 'warning',
        s: 'Failed to sync database, ' + err.message
      })
    })
    sync.on("complete", (info) => {
      console.log("Sync complete ", info);
      // sync.cancel();
    })
    sync.on("error", (info) => {
      console.log("error pouch ");
      console.log("Sync error ", info);
      store.dispatch('changeDBState', {
        a: true,
        m: 'warning',
        s: 'Failed to sync database, ' + info
      })
    });
    }
  },
};